import { render, staticRenderFns } from "./callPolice.vue?vue&type=template&id=718e0f0d&scoped=true&"
import script from "./callPolice.vue?vue&type=script&lang=js&"
export * from "./callPolice.vue?vue&type=script&lang=js&"
import style0 from "./callPolice.vue?vue&type=style&index=0&id=718e0f0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e0f0d",
  null
  
)

export default component.exports